import { render } from "./SalesReturnReport.vue?vue&type=template&id=5e007636&scoped=true"
import script from "./SalesReturnReport.vue?vue&type=script&lang=js"
export * from "./SalesReturnReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=5e007636&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e007636"]])

export default __exports__